module.exports = __webpack_public_path__ + "static/media/集成化2.611a6f18.png";